import React, { useContext, useState } from 'react';
import styles from './listaBalnearioItem.module.scss';
import { BrButton, BrDivider, Col, Row } from '@govbr-ds/react-components';
import { PaginasOutrosRegimes } from '../../../../../../../../../../../../../interfaces/IDadosOutrosRegimes';
import {
  IBalnearioComBanhoLista,
  IBalnearioSemBanhoLista,
} from '../../../../../../../../../../../../../interfaces/IBalneario';
import { DiefCfemContext } from '../../../../../../../../../../../../../contexts/DiefCfemContext';
import { useBackEndRequests } from '../../../../../../../../../../../lib/backEndRequests';
import { useNotificacao } from '../../../../../../../../../../../../../hooks/useNotificacao';
import { Button, Modal } from 'react-dsgov';
import { formatCurrency } from '../../../../../../../../../../../../../utils/formatCurrency';
import CustomConfirmer from '../../../../../../../../../../../../../components/customConfirmer/customConfirmer';
import { formatNumber } from '../../../../../../../../../../../../../utils/formatNumber';

interface IListaBalnearioItemProps {
  setBaseDeCalculo: React.Dispatch<React.SetStateAction<PaginasOutrosRegimes>>;
  index: number;
  setIsEdicao: React.Dispatch<React.SetStateAction<boolean>>;
  comBanho: boolean;
  itemComBanho?: IBalnearioComBanhoLista;
  itemSemBanho?: IBalnearioSemBanhoLista;
  refetchLista: () => void;
  refetchDados: () => void;
}

const ListaBalnearioItem = ({
  setBaseDeCalculo,
  index,
  setIsEdicao,
  comBanho,
  itemComBanho,
  itemSemBanho,
  refetchLista,
  refetchDados,
}: IListaBalnearioItemProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [isModalOpened, setIsModalOpened] = useState(false);

  const context = useContext(DiefCfemContext);

  const { deleteBalneario } = useBackEndRequests();

  const mostrarNotificacao = useNotificacao();

  const deleteItemBalneario = async () => {
    await deleteBalneario(comBanho, (comBanho ? itemComBanho?.id : itemSemBanho?.id) ?? -1)
      .then(() => {
        setIsModalOpened(false);
        refetchLista();
        refetchDados();
      })
      .catch((err) => {
        mostrarNotificacao({
          tipo: 'danger',
          conteudo: 'Erro ao deletar balneário. Por favor, tente novamente.',
          ...(err && { complementoSentryId: err }),
        });
        refetchLista();
        refetchDados();
      });
  };

  return (
    <div className={styles.listaBalnearioContent}>
      <Modal title='Excluir Balneário Selecionado' useScrim modalOpened={isModalOpened}>
        <Modal.Body>Deseja mesmo deletar o balneário selecionado?</Modal.Body>
        <Modal.Footer justify-content='end'>
          <Button secondary small m={2} onClick={() => setIsModalOpened(false)}>
            Cancelar
          </Button>
          <CustomConfirmer asyncCall={() => deleteItemBalneario()}>Confirmar</CustomConfirmer>
        </Modal.Footer>
      </Modal>
      <div
        className={styles.accordion}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <div className={styles.leftContainer}>
          <span className={styles.iconArrow}>
            {!isAccordionOpen ? (
              <i className={`fas fa-chevron-down fa-sm`} />
            ) : (
              <i className={`fas fa-chevron-up fa-sm`} />
            )}
          </span>
          <div className={styles.title}>
            {index} - Balneário - {comBanho ? 'Com Preço de Banho' : 'Sem Preço de Banho'}{' '}
          </div>
        </div>
        <div className={styles.rightContainer}>
          <BrButton
            data-testid='editar-balneario'
            circle
            size='small'
            icon='fas fa-edit fa-sm'
            onClick={() => {
              context?.setIdBalneario(comBanho ? (itemComBanho?.id ?? 0) : (itemSemBanho?.id ?? 0));
              setIsEdicao(true);
              setBaseDeCalculo(comBanho ? 'balnearioComBanho' : 'balnearioSemBanho');
            }}
          />
          <BrButton
            data-testid='deletar-balneario'
            circle
            size='small'
            icon='fas fa-trash fa-sm'
            onClick={() => setIsModalOpened(true)}
          />
        </div>
      </div>
      {isAccordionOpen && (
        <div className={styles.accordionContent}>
          <Row>
            <Col>
              <span className={styles.label}>Código NCM</span>
              <p className={styles.text}>{comBanho ? itemComBanho?.codigoNcm : itemSemBanho?.codigoNcm}</p>
            </Col>
            <Col>
              <span className={styles.label}>Há Preço de Banho Especificado?</span>
              <p className={styles.text}>{comBanho ? 'Sim' : 'Não'}</p>
            </Col>
            <Col></Col>
          </Row>
          <div className={styles.movimentacao}>
            {comBanho ? (
              <Row>
                <Col>
                  <div className={styles.label}>Valor Total do Banho (R$)</div>
                  <p className={styles.text}>{formatCurrency(itemComBanho?.valorBanho ?? '')}</p>
                </Col>
                <Col>
                  <div className={styles.label}>Quantidade </div>
                  <p className={styles.text}>{formatNumber(itemComBanho?.qtdeBanho)}</p>
                </Col>
                <Col className={styles.baseCalculoContainer}>
                  <div className={styles.label}>Preço Médio (R$)</div>
                  <div className={styles.textBaseCalculo}>
                    <span className={styles.text}>{formatCurrency(itemComBanho?.valorPrecoMedio ?? '')}</span>
                  </div>
                </Col>
                <Col className={styles.baseCalculoContainer}>
                  <div className={styles.label}>Base de Cálculo (R$)</div>
                  <div className={styles.textBaseCalculo}>
                    <span className={styles.text}>{formatCurrency(itemComBanho?.valorBaseCalculo ?? '')}</span>
                  </div>
                </Col>
              </Row>
            ) : (
              <>
                <Row className={styles.metodoFormRow}>
                  <Col>
                    <span className={styles.label}>Receita Bruta do Estabelecimento (R$)</span>
                    <p className={styles.text}>{formatCurrency(itemSemBanho?.valorReceitaBruta ?? '')}</p>
                  </Col>
                  <Col></Col>
                </Row>
                <Row>
                  {itemSemBanho?.tributosValores?.map((item) => (
                    <Col key={item.nome} className={styles.tributosContainer}>
                      <span className={styles.label}>{item.nome}</span>
                      <p className={styles.text}>{formatCurrency(item.valor || '')}</p>
                    </Col>
                  ))}
                </Row>
                <div className={styles.metodoDivider}>
                  <BrDivider />
                </div>
                <div className={styles.infoContainer}>
                  <div>
                    <span className={styles.label}>Tributos Incidentes (R$)</span>
                    <p className={styles.text}>{formatCurrency(itemSemBanho?.valorTotalTributos ?? '')}</p>
                  </div>
                  <div>
                    <span className={styles.label}>Receita líquida do estabelecimento (R$)</span>
                    <p className={styles.text}>{formatCurrency(itemSemBanho?.valorReceitaLiquida ?? '')}</p>
                  </div>
                  <div>
                    <span className={styles.label}>Base de Cálculo</span>
                    <p className={styles.text}>{formatCurrency(itemSemBanho?.valorBaseCalculo ?? '')}</p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ListaBalnearioItem;
